import React  from 'react'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import ContentService from '../../services/content'

export default ({ categories }) => (
  <Table>
    <tbody>
    {
      categories.map((category, i) => (
        <tr key={i}>
          <td>
            <ArticleLink to={ContentService.generateArticleUrl(category.id)}>
              {category.name}
              <i className="fa fa-caret-right"/>
            </ArticleLink>
          </td>
        </tr>
      ))
    }
    </tbody>
  </Table>
)

const ArticleLink = styled(Link)`
  i {
    margin-left: .5rem;
  }
`
